import { render, staticRenderFns } from "./Abstract.vue?vue&type=template&id=86ad767a&"
import script from "./Abstract.vue?vue&type=script&lang=js&"
export * from "./Abstract.vue?vue&type=script&lang=js&"
import style0 from "./Abstract.vue?vue&type=style&index=0&id=86ad767a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports